import { AccountActStatus, KafkaNote } from '@nf/utils-common/constants';
import { matchSome } from '@nf/utils-common/fpw/monadic';

import { ApiSiteNameEnums, AthenaSiteNameEnums } from '@nf/types/site';
import type { RawMenuData, RawMarketData } from '@/types/menu-setting';
import type { CheckIsEnabledParameters, NavigationContext } from './types';

export interface BannerConfig {
	checkIsEnabled?: (params: CheckIsEnabledParameters, ctx: NavigationContext) => boolean;
	checkIsUnderMaintain?: () => { isUnderMaintain?: boolean, redirectUrl?: string };
	navigate?: (ctx: NavigationContext) => void | Promise<void>;
	promptForNavigationStopped?: (redirectUrl?: string) => void;
}

const getVirtualMarket = (
	menuResponse: RawMenuData[], 
	gameId: number, 
	marketKey: 'M27' | 'M28' | 'M29'
): string => {
	const virtualData = menuResponse.filter(x => x.GameId === gameId);

	if (virtualData.length > 0 && virtualData[0][marketKey]) {
		return matchSome(virtualData[0][marketKey])
			.on((m: RawMarketData) => m.L > 0, () => 'l')
			.on((m: RawMarketData) => m.WO > 0, () => 'u')
			.on((m: RawMarketData) => m.T > 0, () => 't')
			.otherwise(() => 'e');
	}
	return 'l';
};

export const BANNER_NAV_CONFIG: Record<string, BannerConfig> = {
	'better-esoccer-battle': {
		checkIsEnabled: ({ isBefore }, ctx) => Boolean(!isBefore && ctx.enableESoccerBattlePromotion),
		navigate: ctx => {
			ctx.navigateToSports('/sports/112');
		}
	},
	'e-soccer-virtual': {
		checkIsEnabled: ({ isBefore, user }) => Boolean(
			!isBefore && 
			user?.LicenseeSiteSetting?.EnableBetbyEsoccer
		),
		navigate: ctx => {
			ctx.setKafkaNormal({
				note: KafkaNote.Betby_eSoccer,
				type: ctx.isMars ? 1 : 2,
				action: 5
			});
			ctx.navigateToSports('/sports/116');
		}
	},
	'itcbet1': { 
		checkIsEnabled: ({ siteId }) => siteId === AthenaSiteNameEnums.ITCBet.toString() 
	},
	'itcbet2': {
		checkIsEnabled: ({ siteId }) => siteId === AthenaSiteNameEnums.ITCBet.toString(),
	},
	'itcbet3': {
		checkIsEnabled: ({ siteId }) => siteId === AthenaSiteNameEnums.ITCBet.toString(),
	},
	'itcbet4': {
		checkIsEnabled: ({ siteId }) => siteId === AthenaSiteNameEnums.ITCBet.toString(),
	},
	'itcbet5': {
		checkIsEnabled: ({ siteId }) => siteId === AthenaSiteNameEnums.ITCBet.toString(),
	},
	'itcbet6': {
		checkIsEnabled: ({ siteId }) => siteId === AthenaSiteNameEnums.ITCBet.toString(),
	},
	'itcbet7': {
		checkIsEnabled: ({ siteId }) => siteId === AthenaSiteNameEnums.ITCBet.toString(),
	},
	'itcbet-world-cup-2026': {
		checkIsEnabled: ({ siteId }) => siteId === AthenaSiteNameEnums.ITCBet.toString(),
	},
	'macaubet-new-member': {
		checkIsEnabled: ({ siteId }) => siteId === '4201800',
	},
	'macaubet-slot': {
		checkIsEnabled: ({ siteId }) => siteId === '4201800',
	},
	'macaubet-slot2': {
		checkIsEnabled: ({ siteId }) => siteId === '4201800',
	},
	'macaubet-sports': {
		checkIsEnabled: ({ siteId }) => siteId === '4201800',
	},
	'nba-2k-virtual': {
		checkIsEnabled: ({ isBefore, user }) => Boolean(
			!isBefore && 
			user?.LicenseeSiteSetting?.EnableBetbyBasketball2K
		),
		navigate: ctx => {
			ctx.setKafkaNormal({
				note: KafkaNote.Betby,
				type: ctx.isMars ? 1 : 2,
				action: 5
			});
			ctx.navigateToSports('/sports/134');
		}
	},
	'prediction-market-banner': {
		checkIsEnabled: ({ isBefore }) => !isBefore,
		navigate: ctx => {
			ctx.setKafkaNormal({ note: KafkaNote.PredictionMarket, type: 1, action: 3 });
			ctx.openPredictionMarket();
		}
	},
	'streamer-schedule-banner': {
		checkIsEnabled: ({ isBefore, user }, ctx) => !isBefore &&
				Boolean(user?.ActStatus === AccountActStatus.Deposited) &&
				Boolean(ctx.SiteConfigsData?.EnableStreamerSchedule),
		navigate: ctx => {
			ctx.kafkaLog('HomeBanner', 'StreamerEntertainment');
			ctx.router.push('streamer?type=2', { locale: ctx.locale });
		}
	},
};